import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PPAuthService } from '../../../../core/services/auth.service';
import { User } from '../../../../core/models/user.model';
import { Observable } from 'rxjs';
import { map, tap, filter, first} from 'rxjs/operators';
import { ToastController } from '@ionic/angular';

@Component({
  selector: 'app-name-form',
  templateUrl: './name-form.component.html',
  styleUrls: ['./name-form.component.scss'],
})
export class NameFormComponent implements OnInit {

  form: FormGroup;
  firstName: FormControl;
  lastName: FormControl;
  me$: Observable<User>;
  tryToSubmit = false;
  firstNameFirstBlur = false;
  firstNameFocus = false;
  lastNameFirstBlur = false;
  lastNameFocus = false;

  constructor( private authService: PPAuthService, public toastController: ToastController ) {}

  ngOnInit() {

    this.firstName = new FormControl('', Validators.required);
    this.lastName = new FormControl('', Validators.required);

    //Api doesn't use camelcase in firstname and lastname
    this.form = new FormGroup({
      firstname: this.firstName,
      lastname: this.lastName
    });

    this.me$ = this.authService.me2$.pipe(
      filter( user => !!user ),
      tap( user => {
        console.log( user );
        this.firstName.patchValue( user.firstName );
        this.lastName.patchValue( user.lastName );
      })
    );

  }

  async presentToast( text ) {
    const toast = await this.toastController.create({
      message: text,
      duration: 2000,
      color: 'primary'
    });
    toast.present();
  }

  onFormSubmit() {

    this.tryToSubmit = true;

    if ( !this.form.valid ) {
      return false;
    }

    let onUpdate = (result) => {
      this.authService.setMe();
      this.presentToast( 'Ime je shranjeno.' );
    }

    if ( this.form.valid ) {
      this.authService.updateName( this.form.value ).subscribe( result => onUpdate( result ) )
    }
  }

}
